import Vue from "vue";
import { AuthorizationData, Role, UserType } from "@/features/Authentication/PlatformUserInfoService";

export class IncidentAuthorizationService {
    private authData: AuthorizationData;

    constructor() {
        this.authData = Vue.prototype.$platformUserInfoService.getUserAuthorizationData();
    }

    public canCreateIncident(supplierID: string) {
        // Admins or external users with visibility to the supplier can create incidents for them
        if (this.authData.type == UserType.Internal) {
            if (this.authData.supplierIDs.some(s => s == supplierID) && this.authData.roles.some(r => r == Role.SupplierManager)) {
                return true;
            } else if (this.authData.roles.some(r => r == Role.Admin || r == Role.BusinessLineAdmin)) {
                return true;
            }
        }

        return false;
    }

    public canModifyIncident(supplierID: string) {
        // Admins or external users with visibility to the supplier can modify their incidents
        if (this.authData.type == UserType.Internal) {
            if (this.authData.supplierIDs.some(s => s == supplierID) && this.authData.roles.some(r => r == Role.SupplierManager)) {
                return true;
            } else if (this.authData.roles.some(r => r == Role.Admin || r == Role.BusinessLineAdmin)) {
                return true;
            }
        }

        return false;
    }

    public canViewIncidentAuditableEvents() {
        // Internal users can view incidents' auditable events
        if (this.authData.type == UserType.Internal) {
            return true;
        }

        return false;
    }
}
